import React from "react";
import Layout from "../../layout";
import RulesTable from "../../components/tables/rules";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";

const AdminRulesPage = () => {
    return (
        <Layout pageTitle="Rules" parentUrl="" parentPageName="">
            <Grid item xs={6}>
                <Card>
                    <RulesTable />
                </Card>
            </Grid>
        </Layout>
    );
};

export default AdminRulesPage;
